import type { InsulinActivity } from "@tandemdiabetes/sugarmate-api-react-client"
import type {
  ComponentPropsWithoutRef,
  Ref,
} from "react"
import { forwardRef } from "react"
import { usePolyglot } from "src/contexts"
import { round } from "src/utils"

interface Props extends ComponentPropsWithoutRef<"div"> {
  activity: InsulinActivity;
}

export const InsulinActivityTitle = forwardRef<HTMLDivElement, Props>(
  function InsulinActivityTitle(props: Props, ref: Ref<HTMLDivElement>) {
    const {
      activity,
      ...htmlDivProps
    } = props

    const polyglot = usePolyglot()

    if (!activity.num_units) {
      return null
    }

    return (
      <div
        {...htmlDivProps}
        ref={ref}
      >
        {polyglot.t(
          "unit.num_units_abbreviated",
          {
            units: round(
              activity.num_units,
              3,
            ).toLocaleString(polyglot.locale()),
          },
        )}
      </div>
    )
  },
)
